import {Injectable} from "@angular/core";
import {NgbModal, NgbModalOptions, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ConfirmationModalComponent} from "./modals/confirmation.modal";

@Injectable()
export class ModalService {
    protected openModals: NgbModalRef[] = [];

    constructor( private modalService: NgbModal) {}

    public dismissAll(except?: NgbModalRef) {
        this.openModals.forEach((modal: NgbModalRef) => {
            if (modal === except) {
                return;
            }

            modal.dismiss();
        });
    }

    public confirm(title: string, body: string): Promise<any> {
        let modal = this.custom(ConfirmationModalComponent, {backdrop: "static", size: "lg"});
        modal.componentInstance.title = title;
        modal.componentInstance.body  = body;

        return modal.result;
    }

    public custom(content: any, options?: NgbModalOptions): NgbModalRef {
        options = options || {backdrop: "static", size: "lg"};

        let modal = this.modalService.open(content, options);
        this.openModals.push(modal);

        modal.result.then(
            () => this.openModals.splice(this.openModals.indexOf(modal), 1),
            () => this.openModals.splice(this.openModals.indexOf(modal), 1)
        );

        return modal;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/modal.service.ts